<script setup lang="ts">
import MainSummary from '@desktop/views/Relation/components/RelationView/Main/MainSummary/MainSummary.vue'
import ResultWithSlider from '@desktop/views/Relation/Sports/components/RelationView/Main/Summary/ResultWithSlider.vue'

import Result from '../../Summary/Result.vue'
import SetResult from '../../Summary/SetResult.vue'
import LineupsModal from './Lineups/LineupsModal.vue'
</script>

<template>
  <MainSummary
    :modalOptions="{
      skins: true,
      lineups: LineupsModal,
    }"
  >
    <template #top>
      <SetResult />
    </template>
    <template #result>
      <Result />
    </template>
    <template #bottom>
      <ResultWithSlider />
    </template>
  </MainSummary>
</template>
